import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import driverTicket from './modules/driverTicket'
import support from './modules/support'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    driverTicket,
    support,
  },
  strict: process.env.DEV,
})
